import Vue from 'vue'
import Vuex from 'vuex'

import api from '@/api'

import auth from './auth'
import UserStore from './user'
import CarrierStore from './carrier'
import MilestoneStore from './milestone'
import CodeTypeStore from './codeType'
import EventCodeStore from './eventCode'
import ShipmentStore from './shipment'
import ShipmentFieldsStore from './shipmentFields'
import TemplateStore from './template'
import Stats from './stats'
import TrackingRequestStore from './trackingRequest'
import TeamStore from './team'
import ProjectStore from './project'
import BiStore from './bi'

Vue.use(api)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notification: {
      group: 'global', duration: 2000
    },
    pageSize: 30,
    successMessage: {},
    isManager: false,
    userRol: '',
    roles: {
      standard: {id: 1, prohibitions: []},
      limited: {id: 2, prohibitions: ['canWrite']}
    }
  },
  modules: {
    auth: auth,
    carrier: CarrierStore,
    milestone: MilestoneStore,
    codeType: CodeTypeStore,
    shipment: ShipmentStore,
    stats: Stats,
    trackingRequest: TrackingRequestStore,
    eventCode: EventCodeStore,
    template: TemplateStore,
    user: UserStore,
    shipmentFields: ShipmentFieldsStore,
    team: TeamStore,
    project: ProjectStore,
    bi: BiStore
  },
  mutations: {
    'API_REQUEST' (state) {
      state.errorMessage = null
      state.request_start = true
      state.request_success = false
      state.request_error = false
    },
    'API_REQUEST_SUCCESS' (state, payload) {
      state.request_success = true
      state.request_start = false
    },
    'API_REQUEST_ERROR' (state, payload) {
      payload = Object.assign({ group: 'global', type: 'error', duration: 3000 }, payload)
      state.notification = payload
      state.request_error = true
      state.request_start = false
    },
    'SET_MANAGER_PERMISSIONS' (state, payload) {
      state.isManager = payload.is_manager
      state.userRol = payload.role
    }
  },
  actions: {
    async request ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.apiURL}${config.url}${config.noSlash ? '' : '/'}`
      return api.request(config.method, getters.apiHeaders, url, config.data, config.params
      ).then(response => {
        commit('API_REQUEST_SUCCESS', response.data)
        return response
      }).catch(error => {
        commit('API_REQUEST_ERROR', {
          duration: config.duration,
          title: 'ERROR',
          type: 'error',
          text: apiErrorToHTML(error.response.data)
        })
        throw error
      })
    },
    async contact ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      return api.contact(config).then(response => {
        commit('API_REQUEST_SUCCESS', response.data)
        return response
      }).catch(error => {
        commit('API_REQUEST_ERROR', {
          duration: config.duration,
          title: 'ERROR',
          type: 'error',
          text: apiErrorToHTML(error.response.data)
        })
        throw error
      })
    },
    async download ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.apiURL}${config.url}${config.noSlash ? '' : '/'}`
      return api.download(config.method, getters.apiHeaders, url, config.data, config.params
      ).then(response => {
        commit('API_REQUEST_SUCCESS', response.data)
        return response
      }).catch(error => {
        commit('API_REQUEST_ERROR', {
          duration: config.duration,
          title: 'ERROR',
          type: 'error',
          text: apiErrorToHTML(error.response.data)
        })
        throw error
      })
    },
    async list ({ dispatch, commit, state }, config) {
      var ModelClass = config.modelClass
      return this.dispatch('request', {
        method: 'get',
        url: ModelClass.defaults().basePath,
        params: config.params,
        duration: config.duration
      })
        .then(response => {
          if (config.params && config.params.format) {
            return response
          } else {
            var count = 'count' in response.data ? response.data.count : response.data.length
            var results = 'results' in response.data ? response.data.results : response.data
            var resultDict = { count: count, results: [] }
            results.forEach(element => {
              resultDict.results.push(new ModelClass(element))
            })
            return resultDict
          }
        }).catch(error => {
          throw error
        })
    },
    async retrieve ({ dispatch, commit, state }, config) {
      var ModelClass = config.modelClass
      if (!config.id) { return new ModelClass() }
      var url = `${ModelClass.defaults().basePath}/${config.id}`

      return dispatch('request', { method: 'get', url: url, duration: config.duration })
        .then(response => { return new ModelClass(response.data) })
        .catch(error => { throw error })
    },
    async read ({ dispatch, commit, state }, config) {
      var ModelClass = config.modelClass
      var url = `${ModelClass.defaults().basePath}`

      return dispatch('request', { method: 'get', url: url, duration: config.duration })
        .then(response => { return new ModelClass(response.data) })
        .catch(error => { throw error })
    },
    async save ({ dispatch, commit, state, rootState }, config) {
      var ModelClass = config.modelClass
      var url = ModelClass ? ModelClass.defaults().basePath : config.url
      var method = 'post'
      if (!ModelClass || (config.id && !config.action)) { method = 'put' }

      if (config.id > 0) {
        url = `${url}/${config.id}`
        config.data.id = undefined
      }

      if (config.action) {
        url = `${url}/${config.action}`
      }

      return dispatch('request', { method: method, url: url, data: config.data, duration: config.duration })
        .then(response => {
          state.object = ModelClass ? new ModelClass(response.data) : response.data
          rootState.notification = {
            group: 'global',
            duration: config.duration || 2000,
            type: 'info',
            title: ModelClass ? ModelClass.defaults().name : config.url,
            text: 'Sucessfully saved'
          }
          return state.object
        }).catch(error => { throw error })
    },
    async update ({ dispatch, commit, state, rootState }, config) {
      var ModelClass = config.modelClass
      var url = ModelClass.defaults().basePath

      if (config.id > 0) {
        url = `${url}/${config.id}`
      }

      if (config.action) {
        url = `${url}/${config.action}`
      }

      return dispatch('request', { method: 'put', url: url, data: config.data, duration: config.duration })
        .then(response => {
          state.object = new ModelClass(response.data)
          rootState.notification = {
            group: 'global',
            duration: config.duration || 2000,
            type: 'info',
            title: ModelClass.defaults().name,
            text: 'Sucessfully saved'
          }
          return state.object
        }).catch(error => { throw error })
    },
    async partialUpdate ({ dispatch, commit, state, rootState }, config) {
      var ModelClass = config.modelClass
      var url = ModelClass ? ModelClass.defaults().basePath : config.url
      if (config.id > 0) {
        url = `${url}/${config.id}`
      }
      return dispatch('request', { method: 'patch', url: url, data: config.data, duration: config.duration })
        .then(response => {
          state.object = !ModelClass || ModelClass.rawNew ? response.data : new ModelClass(response.data)
          rootState.notification = {
            group: 'global',
            duration: config.duration || 2000,
            type: 'info',
            title: ModelClass ? ModelClass.defaults().name : config.url,
            text: 'Sucessfully saved'
          }
          return state.object
        }).catch(error => { throw error })
    },
    async updateUser ({ dispatch, commit, state, rootState }, config) {
      var ModelClass = config.modelClass
      var url = ModelClass.defaults().basePath

      return dispatch('request', { method: 'patch', url: url, data: config.data })
        .then(response => {
          state.object = new ModelClass(response.data)
          rootState.notification = {
            group: 'global',
            duration: config.duration || 2000,
            type: 'info',
            title: ModelClass.defaults().name,
            text: 'Sucessfully saved'
          }
          return state.object
        }).catch(error => { throw error })
    },
    async delete ({ dispatch, commit, state, rootState }, config) {
      var ModelClass = config.modelClass
      var url = ModelClass.defaults().basePath + '/' + config.data.id
      return dispatch('request', { method: 'delete', url: url, data: config.data, duration: config.duration })
        .then(response => {
          state.object = new ModelClass(response.data)
          rootState.notification = {
            group: 'global',
            duration: config.duration || 2000,
            type: 'success',
            title: ModelClass.defaults().name,
            text: 'Sucessfully deleted'
          }
          return state.object
        }).catch(error => { throw error })
    },
    async view ({ dispatch, commit, state }, config) {
      return dispatch('request', { method: 'get', url: config.url, duration: config.duration })
        .then(response => { return response.data })
        .catch(error => { throw error })
    }
  },
  getters: {
    apiURL () {
      return Vue.config.app.API_URL
    },
    apiHeaders (state) {
      if (!state.auth.authenticated) { return {} }
      return { 'Authorization': 'Token ' + state.auth.token }
    },
    pageSize (state) { return state.pageSize },
    hasPermission (state) {
      return (actionRequired) => {
        var hasPermision = false
        if (state.userRol) {
          if (state.roles[state.userRol].prohibitions.indexOf(actionRequired) < 0) hasPermision = true
          /* state.userData.roles.forEach(rol => {
            if (state.roles[rol.id].prohibitions.indexOf(actionRequired) < 0) hasPermision = true
          }) */
        } else {
          hasPermision = false
        }
        return hasPermision
      }
    }
  }
})

/* TODO */
function apiErrorToHTML (error) {
  var html = ''
  Object.keys(error).forEach(key => {
    html += `<label>${key}</label>`

    if (error[key].isArray) {
      html += `<ul><li>${error[key].join('</li><li>')}</li></ul>`
    } else {
      html += `<div>${error[key]}</div>`
    }
  })
  return html
}



// WEBPACK FOOTER //
// ./src/store/index.js